var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIsNewSmallEn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 35,
    viewBox: "0 0 70 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M47.9453 18.668V35.0009L68.0038 20.1645L47.9453 18.668Z",
    fill: "url(#paint0_linear_3605_20285)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M67.999 0H2V20.2217H67.999V0Z",
    fill: "#E22424"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8379 13V5.12598H25.9067L30.0425 11.3081V5.12598H31.0415V13H29.9727L25.8369 6.8125V13H24.8379ZM36.5791 11.1631L37.5781 11.2866C37.4206 11.8703 37.1287 12.3232 36.7026 12.6455C36.2765 12.9678 35.7323 13.1289 35.0698 13.1289C34.2355 13.1289 33.5731 12.8729 33.0825 12.3608C32.5955 11.8452 32.3521 11.1237 32.3521 10.1963C32.3521 9.23665 32.5991 8.49186 33.0933 7.96191C33.5874 7.43197 34.2284 7.16699 35.0161 7.16699C35.7788 7.16699 36.4019 7.4266 36.8853 7.9458C37.3687 8.46501 37.6104 9.19548 37.6104 10.1372C37.6104 10.1945 37.6086 10.2804 37.605 10.395H33.3511C33.3869 11.0216 33.5641 11.5015 33.8828 11.8345C34.2015 12.1675 34.599 12.334 35.0752 12.334C35.4297 12.334 35.7323 12.2409 35.9829 12.0547C36.2336 11.8685 36.4323 11.5713 36.5791 11.1631ZM33.4048 9.6001H36.5898C36.5469 9.12028 36.4251 8.76042 36.2246 8.52051C35.9167 8.14811 35.5174 7.96191 35.0269 7.96191C34.5828 7.96191 34.2087 8.11051 33.9043 8.40771C33.6035 8.70492 33.437 9.10238 33.4048 9.6001ZM39.8501 13L38.1045 7.2959H39.1035L40.0112 10.5884L40.3496 11.813C40.3639 11.7521 40.4624 11.36 40.645 10.6367L41.5527 7.2959H42.5464L43.4004 10.6045L43.6851 11.6948L44.0127 10.5938L44.9902 7.2959H45.9302L44.147 13H43.1426L42.2349 9.58398L42.0146 8.61182L40.8599 13H39.8501Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3605_20285",
    x1: 57.9742,
    y1: 37.1223,
    x2: 57.9742,
    y2: -0.347016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E22424"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#E02323"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#D92222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#CD2020"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#BC1E1E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#A61A1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#8B1616"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#6A1111"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#450B0B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#1C0404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIsNewSmallEn);
export default __webpack_public_path__ + "static/media/is_new_small_en.5eb99af01da23754ca3a2367c2a64498.svg";
export { ForwardRef as ReactComponent };